import { useState, useEffect, useContext } from "react";
import { useLocation } from "react-router-dom";
import Products from "./Products";
import BannerInfo01 from "./BannerInfo01";
import Loading from "./Loading";
import { contextProvider } from "../Providers";

const Home = ({ addToCart }) => {
  const { products, loading, filter } = useContext(contextProvider);

  const isFilterProducts = () => {
    
    if(filter === "") return true;

    return products.find( (p) => p.id_categoria === filter)
   
  }

  return (
    <div>
      {loading ? <Loading>Cargando Productos ... </Loading> : isFilterProducts() ? <Products products={products} addToCart={addToCart} /> : "No hay productos por ahora para la categoria seleccionada..." }

      <BannerInfo01 />
    </div>
  );
};

export default Home;
